import { Toast } from "@aurem/ui";
import type { FC } from "react";
import { useCallback, useEffect } from "react";
import { useTranslations } from "./i18n";

export const NetworkStatus: FC = () => {
  const { t } = useTranslations();

  const handleOffline = useCallback(() => {
    Toast.error({
      title: t("components.networkStatus.offline.title"),
      text: t("components.networkStatus.offline.text"),
    });
  }, [t]);

  const handleOnline = useCallback(() => {
    Toast.info({
      title: t("components.networkStatus.online.title"),
      text: t("components.networkStatus.online.text"),
    });
  }, [t]);

  useEffect(() => {
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [handleOffline, handleOnline]);

  return null;
};
